<template>
  <ezine-editions-settings v-if="editionId" :edition-id="editionId" @change-edition="editionId = $event" />
  <ezine-editions-index v-else @change-edition="editionId = $event" />
</template>

<script>
import EzineEditionsIndex from './EzineEditionsIndex.vue'
import EzineEditionsSettings from './EzineEditionsSettings.vue'

export default {
  components: {
    EzineEditionsIndex,
    EzineEditionsSettings
  },
  data () {
    return {
      editionId: null
    }
  }
}
</script>
